import React from 'react';
import {
    AppBar,
    Container,
    Typography,
    Toolbar,
    Grid,
    Button,
    Box,
    Paper,
} from "@mui/material";
import { useUser, UserButton } from "@clerk/clerk-react";

export default function Home() {
    const { isLoaded, isSignedIn, user } = useUser();

    const navigate = (path) => window.location.href = path; // simple replacement for routing

    const handleGetStarted = () => {
        if (isSignedIn && user) {
            console.log("Create user document for", user.id);
            navigate("/generate");
        } else {
            alert("You must be logged in");
            navigate("/sign-in");
        }
    };

    const handleFlashcards = () => {
        if (isSignedIn && user) {
            console.log("Access flashcards for", user.id);
            navigate("/flashcards");
        } else {
            alert("You must be logged in");
            navigate("/sign-in");
        }
    };

    if (!isLoaded) return null; // wait for Clerk to load

    return (
        <Container
            maxWidth="100vw"
            sx={{ backgroundColor: "#9395D3", minHeight: "100vh", py: 4 }}
        >
            <AppBar position="static" sx={{ backgroundColor: "#B3B7EE", borderRadius:"8px" }}>
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#FFF" }}>
                            StudyWise
                        </Typography>
                    </Box>
                    <Box>
                        {isSignedIn ? (
                            <UserButton />
                        ) : (
                            <Button color="inherit" onClick={() => navigate("/sign-in")}>Login / Sign Up</Button>
                        )}
                    </Box>
                </Toolbar>
            </AppBar>

            <Box sx={{ textAlign: 'center', my: 4, py: 10, fontWeight: "bold", color: "#000807" }}>
                <Typography variant="h2" gutterBottom>Welcome to StudyWise</Typography>
                <Typography variant="h5" gutterBottom>The easiest way to create flashcards from your text.</Typography>
                <Box sx={{ my: 4 }}>
                    <Button variant="contained" onClick={handleGetStarted} sx={{ mr: 2 }}>Generate</Button>
                    <Button variant="contained" onClick={handleFlashcards}>Flashcards</Button>
                </Box>
            </Box>

            <Box sx={{ my: 6 }}>
                <Typography variant="h4" gutterBottom sx={{ display: "flex", justifyContent: "center" }}>Features</Typography>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={3} sx={{ p: 3, backgroundColor: "#FBF9FF", borderRadius: "12px" }}>
                            <Typography variant="h6" gutterBottom>Generative AI Flashcards</Typography>
                            <Typography>Automatically generate flashcards based on any topic you provide.</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={3} sx={{ p: 3, backgroundColor: "#FBF9FF", borderRadius: "12px" }}>
                            <Typography variant="h6" gutterBottom>Create up to 10+ Flashcards per Topic</Typography>
                            <Typography>The AI will generate up to 10+ high-quality flashcards per topic.</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={3} sx={{ p: 3, backgroundColor: "#FBF9FF", borderRadius: "12px" }}>
                            <Typography variant="h6" gutterBottom>Powered by ChatGPT 5 </Typography>
                            <Typography>Ensuring accurate and detailed flashcards for in-depth learning.</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={3} sx={{ p: 3, backgroundColor: "#FBF9FF", borderRadius: "12px" }}>
                            <Typography variant="h6" gutterBottom>Save your sets </Typography>
                            <Typography>Your sets will save and always be here for you to review and learn again.</Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}
